import { stationStore } from "../store";
const { playingDate } = stationStore;
class GetCurrentDate {
    currentDate() {
        let today = new Date();
        let month = today.getMonth() + 1;
        let day = today.getDate();
        if (month < 10) {
            month = "0" + month;
        }
        if (day < 10) {
            day = "0" + day;
        }
        let date = today.getFullYear() + '-' + month + '-' + day;
        playingDate.set(date);
    }
}
export const getCurrentDate = new GetCurrentDate();
